/* eslint-disable no-undef */
// remove no-js flag
$('html').removeClass('no-js');

$(document).ready(() => {
  initMobileMenu();
  initFancybox();
  initParallax();
  initSlider();
  initSmallLayoutAnimations();
});

// FIX wrong 100vh in iOS and android jumps when the url bar hides
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
const vh = window.innerHeight * 0.01;
// this is than used as var inside css/less
document.documentElement.style.setProperty('--vh', `${vh}px`);

// submit job searchform on not job list pages
$('.job-search-form .btn-submit').on('click', function (e) {
  let thisForm = $(this).parents('form[data-job-search-form]');
  let url = thisForm.attr('action') + '?';
  let i = 0;
  thisForm.find('input[data-api-name]').each(function () {
    if (i > 0) {
      url += '&';
    }
    url += $(this).data('apiName') +'='+ $(this).val();
    i++;
  });
  location.href = url;
});

const navbarTransitionSpeed = 400;
const vpChangeWidth = 1200;
var isMobile = checkMobile();

$(function () {
  isMobile = checkMobile()
  scrollTop();

  toggleUlClass();
  toggleLvl1UlClass();
  animateMobileNavbar();
  animateDesktopNavbar();
  setThinClassAndHeight();
  setViewportSizeQuery();
  loadingAnimation();
  toggleSidebar();
  // setAnimationValues();
});

function checkMobile() {
  return window.innerWidth < vpChangeWidth;
}

function scrollTop() {
  $(document).on('click', ".ce-f-top-btn", function (e) {
    e.preventDefault();
    $('html, body').animate({scrollTop: 0}, '200');
  });
}

function animateMobileNavbar() {
  //animate main list:--------------------
  $(document).on('click', ".n-burger", function () {
    let ul = $('.n-lvl-0');

    $('.main-navbar').css('height', '');

    if (ul.hasClass('show')) {
      // let height = getNavHeight();
      // ul.css("height", height + "px");
      ul.slideDown(navbarTransitionSpeed);
    } else {
      let subLvls = $('.n-lvl-1, .n-lvl-over1');
      if (subLvls.hasClass("show")) {
        let buttons = $('.n-lvl-0').find('.lvl-0-button.rotate')
        buttons.removeClass('rotate');

        // subLvls.css("height", 0);
        subLvls.slideUp(navbarTransitionSpeed);
        subLvls.removeClass('show');
      }
      // ul.css("height", 0);
      ul.slideUp(navbarTransitionSpeed);
    }
  });

  //animate sub list:-------------------------
  let lvl0Items = $('.main-navbar').find('.lvl-0-item');

  lvl0Items.each(function () {

    if ($(this).find('.n-lvl-1').length > 0) {

      $(document).on('click', ".lvl-0-button", function () {
        let ulLVL0 =  $(this).parents('.n-lvl-0');
        let wrapperLVL0 = ulLVL0.children();
        let subLvlWrapper = $(this).siblings('.n-lvl-1, .n-lvl-over1');
        let subLvlInner = subLvlWrapper.children('.n-height-wrapper-lvl-1, .n-height-wrapper-lvl-over1');

        if (subLvlWrapper.hasClass('show')) {
          $(this).addClass('rotate');

          // let navHeight = getNavHeight() + subLvlInner.outerHeight(true);
          // let subLvlInnerHeight = subLvlInner.outerHeight(true);

          // ulLVL0.css({
          //   "height": navHeight + "px",
          //   "transition": "height 0.6s ease-out"
          // });

          // subLvlWrapper.css("height", subLvlInnerHeight + "px");
          subLvlWrapper.slideDown(navbarTransitionSpeed);

        } else {
          $(this).removeClass('rotate');
          subLvlWrapper.slideUp(navbarTransitionSpeed);
          // let navHeight = wrapperLVL0.outerHeight() - subLvlInner.outerHeight();

          // subLvlWrapper.css("height", "0px");
          // ulLVL0.css("height", navHeight + "px");
        }
      });
    }
  });
}

function animateDesktopNavbar() {
  if (isMobile === false) {
    let mainNavbar = $('.main-navbar');
    let lvl0Items = mainNavbar.find('.lvl-0-item');

    mainNavbar.css('height', '');
    if (mainNavbar.find('.n-lvl-0, .n-lvl-1, .n-lvl-over1').hasClass('show') === true) {
      mainNavbar.find('.n-lvl-0, .n-lvl-1, .n-lvl-over1').css('height', '').removeClass('show');
    }

    lvl0Items.each(function () {
      let lvl1Ul = $(this).find('.n-lvl-1');

      if (lvl1Ul.length > 0) {
        $(this).hover(
            function () {
              if (isMobile === false) {
                // let ulHeight = $(this).find('.n-height-wrapper-lvl-1').outerHeight();
                // lvl1Ul.css("height", ulHeight + "px");
                lvl1Ul.stop().slideDown(navbarTransitionSpeed);
              }
            }, function (e) {
              if (isMobile === false) {
                // lvl1Ul.css("height", "0px");
                lvl1Ul.stop().slideUp(navbarTransitionSpeed);
              }
            }
        );

        let lvl1Items = lvl1Ul.find('.lvl-1-item');
        lvl1Items.each(function () {
          let navbarNextLevel = $(this).find('.n-lvl-over1');
          if (navbarNextLevel.length > 0) {
            $(this).hover(
                function () {
                  if (isMobile === false) {
                    navbarNextLevel.stop().slideDown(navbarTransitionSpeed);
                  }
                }, function (e) {
                  if (isMobile === false) {
                    navbarNextLevel.stop().slideUp(navbarTransitionSpeed);
                  }
                }
            );
          }
        });

      }
    });
  }
}

function toggleUlClass() {
  $(document).on('click', ".n-burger", function () {
    $('.n-lvl-0').toggleClass('show');
  });
}

function toggleLvl1UlClass() {
  $(document).on('click', ".lvl-0-button", function () {
    $(this).siblings('.n-lvl-1, .n-lvl-over1').toggleClass('show');
  });
}

function getNavHeight() {
  return $('.n-height-wrapper-lvl-0').outerHeight()
}

function setViewportSizeQuery() {
  let ViewportSize = window.innerWidth;

  $(window).resize(function () {
    ViewportSize = window.innerWidth;
    isMobile = checkMobile();

    if (isMobile === true) {
    //   // animateMobileNavbar();
      $('.main-navbar').css('height', '');
    } else {
      animateDesktopNavbar();
    //   setThinClassAndHeight();
    }
  });
}

function setThinClassAndHeight() {
  let navbar = $('.main-navbar');
  // normal height Wert direkt zum Anfang holen, weil sonst im else die Transition aus dem CSS noch wirkt
  // und die Höhe manipuliert
  let normalHeight = $('.n-wrapper-desktop').height();
  let scrollValue = navbar.outerHeight();

  $(window).scroll(function () {
    if (isMobile === false) {
      if (window.scrollY >= scrollValue) {
        navbar.addClass("thin");
        let thinHeight = Math.round($('.n-height-wrapper-lvl-0').height());
        navbar.css("height", thinHeight + "px");
      } else {
        navbar.removeClass("thin");
        navbar.css("height", normalHeight + "px");
      }
    }
  });
}

function toggleSidebar() {
  if ($('.ce-sidebar').length > 0) {
    if (isMobile === true) {
      $('.ce-sidebar .ce-s-arrow').addClass('collapsed');
    }
    $(document).on('click', '.ce-s-arrow', function (e) {
      $(this).toggleClass('collapsed');
    });
    $(document).on('click', '.ce-s-c-wrapper', function (e) {
      $(this).parents('.ce-s-contact').addClass('open');
    });
    $(document).on('click', '.ce-s-c-formclose', function (e) {
      $(this).parents('.ce-s-contact').removeClass('open').addClass('closed');
      setTimeout(() => {
        $(this).parents('.ce-s-contact').removeClass('closed');
        document.activeElement.blur();
      }, 900);
    });

    if($('.ce-s-contact .powermail_create').length > 0) {
      $('.ce-s-contact').addClass('open');
    }
  }
}

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

async function loadingAnimation() {
  // delete on DDEV / browsersync
  if (location.host === 'medcareer.de.ddev.site' || location.host === 'localhost:3000') {
    $('.ce-loading-animation').remove();
  }
  let animationSpeed = 250;
  let div = $('.ce-la-text');
  let text = div.text().trim();
  // add puffer
  let maxDuration = (text.length + 2) * animationSpeed;
  if (div.parent().hasClass('finished') === true) {
    return true;
  }
  div.empty();

  const loadingAnimationInterval = setInterval(function(){
      if ($('.ce-la-text').text().trim().length < (text.length / 2)) {
        $('.ce-loading-animation').fadeOut(800).addClass('finished');
        $('body').removeClass('doc-ready');
        clearInterval(loadingAnimationInterval);
      } else if ($('.ce-la-text').text().trim().length === text.length) {
        clearInterval(loadingAnimationInterval);
      }
    }, maxDuration
  );

  for (let i = 0; i < text.length; i++) {
    div.append("<span>" + text[i] + "</span>");
    let letter = $('.ce-la-text span');
    let duration = duration = letter.css('transition-duration');
    // fix miliseconds vs seconds
    duration = (duration.indexOf("ms")>-1) ? parseFloat(duration) : parseFloat(duration)*1000;

    await sleep(duration - i*5);
    letter.last().addClass("animated");

    if (i === text.length - 1) {
      await sleep(animationSpeed);
      removeAnimationOverlay();
    }
  }

  $( document ).ready(function() {
    $('body').addClass('doc-ready');
    removeAnimationOverlay();
  });
}

function removeAnimationOverlay() {
  let $body = $('body');
  let animationDiv = $('.ce-loading-animation');
  if (
      $body.hasClass('doc-ready') === true
      && animationDiv.text().trim().length === animationDiv.find('span').length
  ) {
    $('.ce-loading-animation').fadeOut(800).addClass('finished');
    $body.removeClass('doc-ready');
  }
}
